// Quem entra no PowerData, em toda conta e sem a flag `power_data` (POWERDATA-ACESSO-01,
// 30/09/2026): o administrador e o atendente. São os dois papéis que o servidor deixa passar
// (`PowerAgentsAuthorization`); o que cada um pode fazer lá dentro é o controller que decide.
//
// Arquivo à parte, e não dentro de `powerData.routes.js`, porque o menu também o lê: importar
// as rotas na barra lateral levaria as telas do PowerData para o bundle dela.
//
// `powerdata_manage` (01/10/2026) entra pela mesma razão: o servidor também deixa passar quem a
// recebeu num papel personalizado, o que inclui um moderador com o papel. Para o administrador e o
// atendente a lista não muda nada.
export const PAPEIS_DO_POWER_DATA = [
  'administrator',
  'agent',
  'powerdata_manage',
];
